var _rect, _path, _path2, _path3, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFtthRouter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 20.2861,
    width: 38,
    height: 16.5714,
    rx: 4,
    stroke: "#008CFF",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.42885C11.4545 5.00028 14.8727 2.85742 19.8182 2.85742C24.7636 2.85742 28.4242 5.00028 30 6.42885",
    stroke: "#008CFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2856 10.7141C15.1168 9.857 17.0701 8.57129 19.896 8.57129C22.722 8.57129 24.8138 9.857 25.7142 10.7141",
    stroke: "#008CFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1428 14.2856C17.5584 13.9999 18.535 13.5713 19.948 13.5713C21.361 13.5713 22.4069 13.9999 22.8571 14.2856",
    stroke: "#008CFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 27.1426,
    width: 16.4286,
    height: 2.14286,
    rx: 1.07143,
    fill: "#008CFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.57153,
    y: 27.1426,
    width: 2.14286,
    height: 2.14286,
    rx: 1.07143,
    fill: "#008CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFtthRouter);
export default __webpack_public_path__ + "static/media/FTTHRouter.44ee0649ebdc74614853eb590b67ec60.svg";
export { ForwardRef as ReactComponent };